import { createApp } from 'vue';
import '../style.css';
import App from './App.vue';
import { router } from './router';
import * as Sentry from '@sentry/vue';
import { createPinia } from 'pinia';
import { auth } from '@/firebase-config';

auth.authStateReady().then(() => {
  const app = createApp(App);

  Sentry.init({
    app,
    dsn: 'https://1b8d81e42af2e63be58af8235c4d4558@o4508858880163840.ingest.de.sentry.io/4508858883899472',
    integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
    enabled: import.meta.env.PROD,
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });

  const pinia = createPinia();
  app.use(pinia);

  app.use(router);
  app.mount('#app');
});
